const COLLECTION_ACTIONS = {
    B: "Collected",
    T: "Collected",
    A: "Delivered",
    BD: "Delivered",
    BIBD: "Delivered"
};

const RUN_FLAGS = {
    B: "Collection",
    T: "Collection",
    A: "Delivery",
    BD: "Delivery",
    BIBD: "Delivery"
};

export const getCollectionAction = (collectionCode) => {
    return COLLECTION_ACTIONS[collectionCode];
};

export const getRunFlag = (collectionCode) => {
    return RUN_FLAGS[collectionCode];
}

export const getIsCollectionRun = (collectionCode) => {
    return collectionCode === 'B' || collectionCode === 'T';
}

const RUN_FLAG_BADGE_CLASSES = {
    B: "badge badge-success",
    T: "badge badge-success",
    A: "badge badge-warning",
    BD: "badge badge-warning",
    BIBD: "badge badge-warning"
};

const RUN_FLAG_ICONS = {
    B: "fa fa-arrow-up",
    T: "fa fa-arrow-up",
    A: "fa fa-arrow-down",
    BD: "fa fa-arrow-down",
    BIBD: "fa fa-arrow-down"
};

export const getRunFlagBadgeClass = (collectionCode) => {
    return RUN_FLAG_BADGE_CLASSES[collectionCode];
};

export const getRunFlagIcon = (collectionCode) => {
    return RUN_FLAG_ICONS[collectionCode];
};

const COLLECTION_CARD_STYLE = {
    borderLeft: '6px solid #4dbd74',
    backgroundColor: '#f2fdf5',
};

const DELIVERY_CARD_STYLE = {
    borderLeft: '6px solid #f0ad4e',
    backgroundColor: '#fef9f0',
};

const RUN_TYPE_CARD_STYLES = {
    B: COLLECTION_CARD_STYLE,
    T: COLLECTION_CARD_STYLE,
    A: DELIVERY_CARD_STYLE,
    BD: DELIVERY_CARD_STYLE,
    BIBD: DELIVERY_CARD_STYLE,
};

export const getRunTypeCardStyle = (collectionCode) => {
    return RUN_TYPE_CARD_STYLES[collectionCode] || {};
};

const COLLECTION_RUN_CODES = ['B', 'T'];
const DELIVERY_RUN_CODES = ['A', 'BD', 'BIBD'];

export const isCollectionRunCode = (collectionCode) => COLLECTION_RUN_CODES.includes(collectionCode);
export const isDeliveryRunCode = (collectionCode) => DELIVERY_RUN_CODES.includes(collectionCode);

// Returns whether a pickup is urgent in the context of the run it's on.
// A location can have both urgent collection and urgent delivery requests, but only the
// one matching the run's type is relevant to that pickup.
export const isPickupUrgentForRunType = (pickup, collectionCode) => {
    if (!pickup) return false;
    if (isCollectionRunCode(collectionCode)) return !!pickup.isUrgentCollection;
    if (isDeliveryRunCode(collectionCode)) return !!pickup.isUrgentDelivery;
    return !!pickup.isUrgentJob;
};

export const getRelevantUrgentText = (pickup, collectionCode) => {
    if (isCollectionRunCode(collectionCode)) return 'URGENT COLLECTION';
    if (isDeliveryRunCode(collectionCode)) return 'URGENT DELIVERY';
    return pickup?.isUrgentDelivery ? 'URGENT DELIVERY' : 'URGENT COLLECTION';
};